export default __webpack_public_path__ + "static/media/rabbit25.51c80b7f.gif";